angular.module("EICDataStream3.exports", [])
  .config(function() {
  })

  // ExportController is here to satisfy the top level of the ui-router (don't delete it!)
  .controller('ExportController',
    [
      '$scope', '$state',
      function($scope, $state) {
        $scope.componentName = "ExportController";

        $scope.title = 'Exports';

      }
    ])
  .controller('ExportRequestController',
    [
      '$scope',
      '$uibModalInstance',
      'data',
      'exportRequestService',
      'FEATURE_SWITCHES',
      function($scope,
        $uibModalInstance,
        data,
        exportRequestService,
        FEATURE_SWITCHES) {

        $scope.componentName = "ExportRequestController";
        $scope.NEW_EXPORTS = FEATURE_SWITCHES.NEW_EXPORTS;

        $scope.exportParams = data.exportParams;


        var errorCallback = function(response) {
          $scope.success = false;
          $scope.requestSent = true;

          $scope.message = response.statusText;
          $scope.requestSentCloseButtonCaption = "Cancel";
          $scope.messageStyle = { 'color': 'red' };
        };


        var closeDialog = function() {
          $uibModalInstance.dismiss('Canceled');
        };


        $scope.cancel = function() {
          closeDialog();
        };


        var showSuccessDialog = function() {
          $scope.success = true;
          $scope.requestSent = true;

          $scope.message =
            "Your export is being prepared and will download shortly.";
          $scope.requestSentCloseButtonCaption = "OK";
          $scope.messageStyle = { 'color': 'black' };
        };


        $scope.downloadExport = function(projectIds) {
          console.log("Download Test");
          exportRequestService.downloadExport($scope.exportParams)
            //.then(successCallback) //, errorCallback)
            // .then(runReport)
            .then(showSuccessDialog)
            .catch(errorCallback);
        };


        $scope.hitEnter = function(evt) {
          if (angular.equals(evt.keyCode, 13) &&
            !(angular.equals($scope.user.name, null) || angular.equals($scope.user.name, '')))
            $scope.save();
        };


        $scope.normaliseFilename = function() {
          if (!$scope.exportParams.fileName) $scope.exportParams.fileName = "ProjectExport";

          $scope.exportParams.fileName = $scope.exportParams.fileName
            .trim()
            .replace(/\s\s+/g, ' ')
            .replace(/[\\\/:*?"<>|]{1,}/g, "_")
            .replace(/.xlsx|.xls/, "");
        };

        $scope.$on('$viewContentLoaded',
          function() {
          });

      }
    ])
  .service('exportRequestService',
    [
      '$http', 'dialogService', 'projectDataService', 'trackingStatusService',
      function($http, dialogService, projectDataService, trackingStatusService) {

        //////////////////////////////////////////////////////////////////////
        ////  Export Request Support Functions
        //////////////////////////////////////////////////////////////////////

        var getSelectedProjectIDs = function () {
          return projectDataService.projectNames
            .filter(function (item, index, ar) {
                if (item.isChecked) return true;
              }
            ).map(function (item, index, ar) {
                return item.projectID;
              }
            );
        };

        var getAllVisibleProjectIDs = function () {
          return projectDataService.projectNames
            .filter(function (item, index, ar) {
              if (trackingStatusService.selectedValues.indexOf(item.trackingStatusID) > -1) return true;
            })
            .map(function (item, index, ar) {
                return item.projectID;
              }
            );
        };




        //////////////////////////////////////////////////////////////////////
        ////  Open dialog for New Export Request - Selected Projects
        //////////////////////////////////////////////////////////////////////

        this.openProjectExportRequestDialog = function() {

          var projectIds = getSelectedProjectIDs();

          // HACK ALERT
          // if no projects have been explicitly chosen, then select all
          // those that  match the TrackingStatus selection
          if (projectIds.length === 0) {
            projectIds = getAllVisibleProjectIDs();
          }

          var exportParams = {
            exportFormat: 0,
            fileName: "ProjectExport",
            projectIds: projectIds,
            contracts: "None",
            contractSelection:0,
            includeContractors: true,
            includeEquipment:false
          };


          dialogService.openExportRequestDialog(exportParams);
        };


        this.downloadExport = function(exportParams) {
          console.log("about to send the request");

          exportParams.fileName = exportParams.fileName + ".xlsx";

          if (exportParams.contracts === "None") {
            exportParams.includeContractors = false;
            exportParams.includeBidders = false;
          } else if (exportParams.contracts === "EPC") {
            exportParams.epcOnly = true;
          } else {
            exportParams.contracts = "All";
          }


          var fileName = exportParams.fileName;

          // This works on Chrome, Firefox and Edge
          // This DOESN'T work on IE11
          return $http.post('/api/requestprojectexport',
              exportParams,
              {
                responseType: "blob"
              })
            .then(function(response) {
              var link = document.createElement('a');
              link.href = window.URL.createObjectURL(response.data);
              link.download = fileName;

              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            })
            .catch(function(e) {
              console.log(e);
            });


        };

      }
    ]);



